import {
  Atom, Waves, Citrus, Sprout, Droplets, Leaf, Hexagon, Radio, Snowflake, ShieldCheck, FlaskConical,
} from "lucide-react";

// Generic icon key -> lucide component. Science articles store one of these keys.
export const SCIENCE_ICONS = {
  hexagon: Hexagon,
  radio: Radio,
  snowflake: Snowflake,
  shield: ShieldCheck,
  waves: Waves,
  citrus: Citrus,
  sprout: Sprout,
  droplets: Droplets,
  leaf: Leaf,
  flask: FlaskConical,
  atom: Atom,
};

// Options for the Admin icon picker.
export const SCIENCE_ICON_OPTIONS = [
  { value: "hexagon", label: "Hexagon (graphene)" },
  { value: "radio", label: "Radio waves (terahertz)" },
  { value: "snowflake", label: "Snowflake (cooling)" },
  { value: "shield", label: "Shield (antibacterial)" },
  { value: "waves", label: "Waves (marine)" },
  { value: "citrus", label: "Citrus (fruit)" },
  { value: "sprout", label: "Sprout (herb/veg)" },
  { value: "droplets", label: "Droplets (algae)" },
  { value: "leaf", label: "Leaf (herbal)" },
  { value: "flask", label: "Flask (science)" },
  { value: "atom", label: "Atom (default)" },
];

export const SCIENCE_GROUP_OPTIONS = [
  { value: "Technology", label: "Technology" },
  { value: "Herbal & Marine", label: "Herbal & Marine" },
];

const keywordIconKey = (title = "") => {
  const t = title.toLowerCase();
  if (t.includes("graphene")) return "hexagon";
  if (t.includes("terahertz") || t.includes("infrared")) return "radio";
  if (t.includes("silky") || t.includes("cool")) return "snowflake";
  if (t.includes("antibacterial") || t.includes("protection")) return "shield";
  if (t.includes("sea cucumber") || t.includes("gamat")) return "waves";
  if (t.includes("passion") || t.includes("markisa")) return "citrus";
  if (t.includes("bitter gourd") || t.includes("ampalaya")) return "sprout";
  if (t.includes("chlorella") || t.includes("algae")) return "droplets";
  if (t.includes("gymnema") || t.includes("herb")) return "leaf";
  return "atom";
};

// Map a free-text element title -> a science article slug (keyword based so
// admin-added science rows on products still resolve to the right deep-dive page).
export const slugForScience = (title = "") => {
  const t = title.toLowerCase();
  if (t.includes("graphene")) return "graphene";
  if (t.includes("terahertz") || t.includes("infrared")) return "terahertz";
  if (t.includes("silky") || t.includes("cool")) return "silky-cool";
  if (t.includes("antibacterial") || t.includes("protection")) return "antibacterial";
  if (t.includes("sea cucumber") || t.includes("gamat")) return "sea-cucumber";
  if (t.includes("passion") || t.includes("markisa")) return "passion-fruit";
  if (t.includes("bitter gourd") || t.includes("ampalaya")) return "bitter-gourd";
  if (t.includes("chlorella") || t.includes("algae")) return "chlorella";
  if (t.includes("gymnema") || t.includes("herb")) return "gymnema";
  return null;
};

// Accepts an explicit icon key (e.g. "hexagon") or a free-text title.
export const getScienceIcon = (titleOrKey = "") => {
  if (SCIENCE_ICONS[titleOrKey]) return SCIENCE_ICONS[titleOrKey];
  return SCIENCE_ICONS[keywordIconKey(titleOrKey)] || Atom;
};

export const SCIENCE_DISCLAIMER =
  "Paalala: Ang impormasyon dito ay para sa edukasyon lamang at hindi pamalit sa payo ng doktor o propesyonal sa kalusugan. Ang mga product ay hindi nilalayong mag-diagnose, mag-treat, o mag-cure ng anumang sakit.";
